import React ,{useState,useEffect,useRef} from 'react';
import { RiSendPlane2Fill} from "react-icons/ri";
import Pregunta from './pregunta';
import {BsFillCaretLeftFill, BsFillCaretRightFill } from "react-icons/bs";

const Marker=({texto, select})=>{
  
  const [state,setState] = useState(false);
  const [text,setText] = useState('');
  useEffect(()=>{
    setState(select);
    setText(texto);
  },[select,texto])
  return(
    <div className= {`m-1 mx-1 px-3 py-2 border text-primary rounded-lg ${state?
      'bg-primary border-primary text-white':
      'exam-card border-gray-400'
    } `}>
      <p
        className={`text-center font-bold text-sm ${state? 'text-white':'text-primary'}`}
      >{text}</p>
      
    </div>
  );
}

export default function Materia  (props) {
  const {revision, siguenteMateria, anteriorMateria, cantidadMateria, index} = props;

  //const data = props.data.preguntas;
  const [revision_,setRevision_] = useState(revision);
  const [data,setData] = useState(props.data.preguntas);
  useEffect(()=>{
    setRevision_(revision);
  },[revision])

  useEffect(()=>{
    setData(props.data.preguntas);
  },[props.data])
  return(
    <>
        <div className='w-3/4 flex flex-col justify-start items-center overflow-scroll h-screen pt-20 exam-main px-6 pb-24' style={{overflowX:'hidden',
        display:`${props.display}`,
      }}>
         
          <div className='flex flex-row justify-center items-center absolute items-self-end justify-self-end mt-full exam-markers border p-1 rounded-xl' style={{marginTop:'40%'}}>
          {
           data.map((item,index)=>{
             return(
                <Marker texto={index+1} select={item.marcado?true:false}/>
             )
            })
         }
          </div>
          {
            data.map((item,index)=>{
              return(
                <Pregunta 
                  marcado={item.marcado?item.marcado:null} 
                  idPregunta={item.id}
                  materia={item.materia}
                  key={index}
                  index={index+1}
                  pregunta={item.pregunta}
                  respuestas={item.opciones}
                  correct={item.opcionCorrecta}
                  revision={revision_}
                  explicacionCorrecta={item.explicacionCorrecta}
                  item={item}
                />
                  
              )
            })
          }
          <div className='flex flex-row justify-center' >
            {
              index!==0?
                <button className='flex flex-row items-center ali bg-primary text-white py-2 px-4 rounded-full mt-5 mx-4 font-semibold hover:bg-fondo' onClick={()=>{anteriorMateria()}}>
                  <BsFillCaretLeftFill className='text-white'/>
                  Anterior Materia
                </button>
              :null}
            {
              index!==cantidadMateria-1?
                <button className='flex flex-row items-center bg-primary text-white py-2 px-4 rounded-full mt-5 mx-4 font-semibold hover:bg-fondo' onClick={()=>{siguenteMateria()}}>
                  Siguiente Materia
                  <BsFillCaretRightFill className='text-white'/>
                </button>
                :
                null

            }
            
          </div>
          
        </div>
    </>
    );
};